import { cn } from "@/lib/utils";
import Link from "next/link";
import React from "react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
}

const ButtonSimple = ({ className, children, ...props }: Props) => {
  return (
    <button
      {...props}
      className={cn(
        "wireless-Medium inline-flex items-center justify-center rounded-lg bg-system-primary px-3.5 pt-[2px] align-text-bottom text-sm font-medium !leading-[0] text-system-disabled ring-offset-background transition-all duration-300 hover:bg-system-active focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-2 sm:text-base",
        className
      )}
    >
      {children}
    </button>
  );
};

export const ButtonOutline = ({ className, children, ...props }: Props) => {
  return (
    <button
      {...props}
      className={cn(
        "inline-flex w-full items-center justify-center rounded-lg border border-system-titanium px-6 pt-[2px] align-text-bottom text-sm font-medium !leading-[0] text-system-disabled transition-colors hover:bg-system-graphite sm:text-base",
        className
      )}
    >
      <span>{children}</span>
    </button>
  );
};

interface LinkButtonSimpleProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  className?: string;
}

export const LinkButtonSimple = ({
  href,
  className,
  children,
  ...props
}: LinkButtonSimpleProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <Link
      href={href}
      onClick={handleClick}
      className={cn(
        "wireless-Medium inline-flex items-center justify-center rounded-sm bg-system-primary px-[14px] pt-[2px] align-text-bottom text-[15px] font-medium !leading-[0] text-system-disabled ring-offset-background transition-all duration-300 hover:bg-system-active focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-2",
        className
      )}
      {...props}
    >
      {children}
    </Link>
  );
};
export const LinkButton = ({ href, className, children, ...props }: LinkButtonSimpleProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <Link
      href={href}
      onClick={handleClick}
      className={cn("text-system-primary", className)}
      {...props}
    >
      {children}
    </Link>
  );
};

export default ButtonSimple;
